module.exports = "fragment Amount on Amount {\n  amount\n  currency\n  description\n}\n"